import React from 'react'
import styles from './DocumentView.module.scss'

const ACTION_ICONS = {
  created:   '📝',
  signed:    '✅',
  returned:  '↩️',
  approved:  '🎉',
  sent_acq:  '📤',
  cancelled: '🚫',
}

const ACTION_COLORS = {
  created:   '#1d4ed8',
  signed:    '#15803d',
  returned:  '#b91c1c',
  approved:  '#059669',
  sent_acq:  '#7c3aed',
  cancelled: '#6b7280',
}

function fmtDate(str) {
  if (!str) return ''
  const d = new Date(str)
  if (isNaN(d.getTime())) return str
  return d.toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

export default function DocHistory({ activities = [] }) {
  if (!activities.length) {
    return (
      <div className={styles.historySection}>
        <h3 className={styles.panelSectionTitle}>История документа</h3>
        <p className={styles.emptySub}>История событий пуста</p>
      </div>
    )
  }

  return (
    <div className={styles.historySection}>
      <h3 className={styles.panelSectionTitle}>
        История документа
        <span className={styles.commentCount}>{activities.length}</span>
      </h3>

      <div className={styles.timeline}>
        {activities.map((a, i) => {
          const color = ACTION_COLORS[a.action] || '#64748b'
          return (
            <div key={a.id} className={styles.timelineItem}>
              <div className={styles.timelineLeft}>
                <div
                  className={styles.timelineIcon}
                  style={{ color, borderColor: color + '33', background: color + '10' }}
                >
                  {ACTION_ICONS[a.action] || '•'}
                </div>
                {i < activities.length - 1 && <div className={styles.timelineLine} />}
              </div>

              <div className={styles.timelineContent}>
                <span className={styles.timelineAction} style={{ color }}>
                  {a.action_display}
                </span>
                {a.employee_name && (
                  <span className={styles.timelineEmployee}>
                    {a.employee_name}
                    {a.employee_dept && (
                      <span className={styles.timelineDept}> · {a.employee_dept}</span>
                    )}
                  </span>
                )}
                {a.note && <span className={styles.timelineNote}>{a.note}</span>}
                <span className={styles.timelineDate}>{fmtDate(a.created_at)}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
